import { createStore } from 'zustand/vanilla';
import type { i18n } from 'i18next';
import { type Language, languages } from '@/shared';

export interface LanguageStore {
	currentLangCode: Language;
	changeLanguage: (langCode: Language) => Promise<void>;
}

const langCodeToLocaleMap: Record<Language, string> = {
	[languages.English]: 'en',
	[languages.Spanish]: 'es',
	[languages.Catalan]: 'ca',
	[languages.Euskera]: 'eu',
	[languages.Gallego]: 'gl',
	[languages.German]: 'de',
	[languages.French]: 'fr',
	[languages.Korean]: 'ko',
	[languages.Chinese]: 'zh',
	[languages.Japanese]: 'ja',
	[languages.Portuguese]: 'pt',
	[languages.Russian]: 'ru',
	[languages.Italian]: 'it',
	[languages.Dutch]: 'nl',
	[languages.Greek]: 'el',
};

const localesToLangCodeMap: Record<string, Language> = {
	en: languages.English,
	es: languages.Spanish,
	ca: languages.Catalan,
	eu: languages.Euskera,
	gl: languages.Gallego,
	de: languages.German,
	fr: languages.French,
	ko: languages.Korean,
	zh: languages.Chinese,
	ja: languages.Japanese,
	pt: languages.Portuguese,
	ru: languages.Russian,
	it: languages.Italian,
	nl: languages.Dutch,
	el: languages.Greek,
};

export const transformToLangCode = (locale: string) => localesToLangCodeMap[locale];
export const transformToLocale = (langCode: Language) => langCodeToLocaleMap[langCode as Language];

export function createLanguageStore(i18n: i18n, currentLangCode: Language) {
	return createStore<LanguageStore>()((set, get) => ({
		currentLangCode,
		changeLanguage: async (lang) => {
			if (lang === get().currentLangCode) return;

			await i18n.changeLanguage(transformToLocale(lang));
			set({ currentLangCode: lang });
		},
	}));
}
